/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The AuthorityOption model module.
* @module model/AuthorityOption
* @version 2020-12-7
*/
export default class AuthorityOption {
    /**
    * Constructs a new <code>AuthorityOption</code>.
    * 権限
    * @alias module:model/AuthorityOption
    * @class
    * @param id {Number} 権限ID
    * @param name {String} 権限名
    */

    constructor(id, name) {
        
        
        this['id'] = id;
        this['name'] = name;
        
    }

    /**
    * Constructs a <code>AuthorityOption</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/AuthorityOption} obj Optional instance to populate.
    * @return {module:model/AuthorityOption} The populated <code>AuthorityOption</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AuthorityOption();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }

    /**
    * 権限ID
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * 権限名
    * @member {String} name
    */
    'name' = undefined;




}
